export default __webpack_public_path__ + "static/media/budget_preparation.9e997c00.jpg";